import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaSpotify,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";

const SocialIcons = () => {
  return (
    <div className="flex  items-center lg:items-end justify-center lg:justify-start flex-col gap-2 w-[5rem] text-yellow-600">
      <p className="text-lg font-bold text-yellow-900">تابعنا</p>
      <div className="flex items-center justify-center gap-1">
        {/* <a href=""> */}
        <FaFacebook />
        {/* </a> */}
        {/* <a href=""> */}
        <FaYoutube />
        {/* </a> */}{" "}
      </div>
      <div className="flex items-center justify-center gap-1">
        {/* <a href=""> */}
        <FaInstagram />
        {/* </a> */}
        {/* <a href=""> */}
        <FaXTwitter />
        {/* </a> */}{" "}
      </div>
      <div className="flex items-center justify-center gap-1">
        {/* <a href=""> */}
        <FaLinkedin />
        {/* </a> */}
        {/* <a href=""> */}
        <FaSpotify />
        {/* </a> */}{" "}
      </div>
    </div>
  );
};

export default SocialIcons;
